import styled from 'styled-components';

/**
 * The layer utility is for assigning z-index priority within a page. Useful for managing layout
 * without respect to a global system of heirarchy by creating overriding stacking contexts:
 * https://developer.mozilla.org/en-US/docs/Web/CSS/z-index
 *
 * e.g. content from layer:priority:3 will always show on top of layer:priority:2
 * <div>
 *  <Layer $priority={3} />
 *  <Layer $priority={2} />
 * </div>
 */
export const Layer = styled.div`
  position: relative;
  z-index: ${({ $priority }: { $priority: number }) => $priority};
`;
